module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="contacts-metainfo">\n    <h4 class="contacts-count"></h4>\n</div>\n\n<ul class="contacts-list"></ul>';
}
return __p;
};